function t(n){return n instanceof Date}export{t as a};
